<template>
  <div class="br-rejected">
    <div class="br-rejected__icon-wrap" aria-hidden="true">
      <img
        :src="docFailIconUrl"
        class="br-rejected__icon"
        width="72"
        height="72"
        alt=""
      />
    </div>

    <h2 class="br-rejected__title">{{ $t('lbl_EMPBE_BR_Rejected_Title') }}</h2>

    <div class="br-rejected__details">
      <div v-if="displayReason" class="br-rejected__reason-box">
        <img
          :src="rejectedReasonIconUrl"
          class="br-rejected__reason-icon"
          width="20"
          height="20"
          alt=""
        />
        <p class="br-rejected__reason-text">
          <strong>{{ $t('lbl_EMPBE_BR_Rejected_ReasonLabel') }}</strong>
          {{ displayReason }}
        </p>
      </div>

      <p class="br-rejected__body">
        {{ $t('lbl_EMPBE_BR_Rejected_BodyLine1') }}<br />
        {{ $t('lbl_EMPBE_BR_Rejected_BodyLine2') }}{{ $t('lbl_EMPBE_BR_Rejected_HelpPrefix') }}
        <a href="#" class="br-rejected__link" @click.prevent="$emit('contact')">
          {{ $t('lbl_EMPBE_BR_Pending_ContactUs') }}
        </a>{{ $t('lbl_EMPBE_BR_Pending_HelpSuffix') }}
      </p>
    </div>
    <button
      type="button"
      class="br-confirm__submit-btn"
      @click="$emit('reupload')"
    >
      {{ $t('lbl_EMPBE_BR_Rejected_ReuploadBtn') }}
    </button>
  </div>
</template>

<script>
import { BR_LICENSE_ASSETS } from '../../../constants/brLicenseAssets';
import { resolveBrRejectReasonText } from '../utils/brDocument';

export default {
  name: 'BrRejectedApproval',
  props: {
    reason: { type: String, default: '' },
  },
  computed: {
    docFailIconUrl() {
      return BR_LICENSE_ASSETS.docFailIcon;
    },
    rejectedReasonIconUrl() {
      return BR_LICENSE_ASSETS.rejectedReasonIcon;
    },
    displayReason() {
      return resolveBrRejectReasonText({ rejectReason: this.reason }, this.$t.bind(this));
    },
  },
};
</script>
